<template>
  <div id="upgrade" class="p-text-center cursorpointer" @click="goRouter('/billing')">
    <font-awesome-icon class="menuIcon" style="color: black; font-size: 1.2em" :icon="['far', 'lock-alt']" />&nbsp;
    {{ $t("UpgradeBanner.prompt_upgrade_to_full_access") }}
  </div>
</template>

<script>
export default {
  props: ["message"],
  methods: {},
};
</script>

<style scoped lang="scss">
#upgrade {
  width: 100%;
  background: #ccff90;
  padding: 15px;
  padding-top: 25px;
  border-radius: 10px;
  margin-bottom: 10px;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
